import { useEffect } from 'react';
import { centerMapOnJursidiction } from './utils';

const useCenterMap = ({
  map,
  boundingBox,
  hasW3w,
  triggerViewJurisdiction,
}) => {
  /**
   * centerMapOnJursidiction already checks a lot of the
   * data, so I removed the duplicate checks.  Also adjusted the dependency to
   * only trigger and update when hasW2W or triggerViewJurisdiction changes.
   * Ticket: https://rapidsos.atlassian.net/browse/SOUP-5
   */
  useEffect(() => {
    if (!hasW3w) {
      centerMapOnJursidiction(boundingBox, map);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally only re-center on triggerViewJurisdiction change, not on every boundingBox/map/hasW3w update
  }, [triggerViewJurisdiction]);
};

export default useCenterMap;
